import "./SocialAccountInfo.css";
import { BrandIcon, normalizePlatform } from "@ui/BrandIcon";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { Stack } from "@ui/Stack";
import { Show } from "solid-js";
import { isDirectUploadPlatform } from "~/modules/shared/utils/sourceFilterOptions";

const handleUrl = (handle: string, platform: string) => {
	return `https://${platform}.com/@${handle}`;
};

export const SocialAccountInfo = (props: {
	class?: string;
	platform?: string;
	handle?: string;
	name?: string;
	avatar?: string;
	showPlatformLogoIfNoAvatar?: boolean;
	labelOverride?: string;
	label?: string;
}) => {
	const isDirectUpload = () => isDirectUploadPlatform(props.platform);
	const handleHref = () => {
		if (isDirectUpload() || !props.handle || !props.platform) {
			return undefined;
		}
		return handleUrl(props.handle, props.platform);
	};

	return (
		<Stack
			class={`social-account-info ${props.class ?? ""}`}
			direction="row"
			spacing="medium"
			align="center"
		>
			{props.avatar ? (
				<img
					class="avatar"
					data-shimmer-ghost
					src={props.avatar}
					alt={props.name ?? props.handle}
				/>
			) : isDirectUpload() ? (
				<span class="social-platform-logo social-platform-logo--direct-upload">
					<MaterialSymbol symbol="upload" relativeSize={1.75} />
				</span>
			) : props.showPlatformLogoIfNoAvatar && props.platform ? (
				<span
					class="social-platform-logo"
					data-shimmer-ghost
					data-platform={normalizePlatform(props.platform)}
				>
					<BrandIcon
						class="platform-icon"
						platform={props.platform}
						width="1.75rem"
						height="1.75rem"
					/>
				</span>
			) : null}
			{props.handle || props.name ? (
				<Stack class="details" direction="column" spacing="small">
					<Stack
						direction="row"
						spacing="medium"
						align="center"
						justify="space-between"
					>
						<span class="name">{props.name ?? props.handle}</span>
						<Show when={props.label}>
							<span class="label">{props.label}</span>
						</Show>
					</Stack>
					<Stack class="handle" direction="row" spacing="small">
						<Show when={props.platform && !isDirectUpload()}>
							<BrandIcon
								class="platform-icon"
								platform={props.platform}
							/>
						</Show>
						{props.labelOverride ? (
							<span class="label">{props.labelOverride}</span>
						) : handleHref() ? (
							<a href={handleHref()} target="_blank" class="handle">
								@{props.handle}
							</a>
						) : (
							<span class="handle">@{props.handle}</span>
						)}
					</Stack>
				</Stack>
			) : null}
		</Stack>
	);
};
